
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.538 3.231H3.461v5.846h1.462v10.231a1.462 1.462 0 001.461 1.462h11.231a1.462 1.462 0 001.462-1.462V9.077h1.461zm-1.462 4.385H4.923V4.693h14.153zm-1.461 11.692H6.384V9.077h11.231zm-8-8.769h-.308V12h5.385v1.462H9.307z","fill":"currentColor"}})])
          )
        }
      }
    